<template>
  <VLink
    v-if="tender.orderPositions.length === 1"
    class="ellipsis"
    :disabled="$core.currentPartner.isSeller === true && tender.hasOwnOrderPositions === false"
    :title="`${tender.orderPositions[0].id} - ${tender.orderPositions[0].qty.format(tender.unit)}`"
    @click="openPositionCard(tender.orderPositions[0])"
  >
    <!--Удалённая позиция остаётся в списке ссылкой, но красной: заказа по ней больше нет -->
    <span :class="{'critical': tender.orderPositions[0].isDeleted === true}">
      {{ $core.utils.string.formatWithDelimiter(tender.orderPositions[0].id) }} -
      {{ tender.orderPositions[0].qty.format(tender.unit) }}
    </span>
  </VLink>

  <VPopover
    v-else
    trigger="click"
    position="bottom"
    :css-classes="['tender-orders-popup']"
    :visible="isPopupVisible"
    @update:visible="isPopupVisible = $event"
  >
    <template #content>
      <ul>
        <li
          v-for="position in tender.orderPositions"
          :key="position.id"
        >
          <VButton
            theme="link"
            :disabled="$core.currentPartner.isSeller === true && position.seller.id !== $core.currentPartner.id"
            @click="openPositionCard(position)"
          >
            <!--Удалённая позиция остаётся в списке ссылкой, но красной: заказа по ней
            *  больше нет -->
            <span :class="{'critical': position.isDeleted === true}">
              {{ $core.utils.string.formatWithDelimiter(position.id) }}
            </span>
          </VButton>
          - {{ position.qty.format(tender.unit) }}
        </li>
      </ul>
    </template>

    <VButton
      v-if="$core.utils.isNotEmptyArray(tender.orderPositions) === true"
      theme="link"
      :disabled="$core.currentPartner.isSeller === true && tender.hasOwnOrderPositions === false"
      class="nowrap"
    >
      Сформировано - {{ tender.orderPositions.length }}
    </VButton>
    <div v-else>
      Нет заказов
    </div>
  </VPopover>
</template>

<style lang="scss">
.tender-orders-popup {
  padding: 10px;

  li {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
}
</style>

<script lang="ts">
import type Tender from '@/domains/Tenders/Tender';
import type OrderPosition from '@/domains/Orders/OrderPosition';
import {UnwrapNestedRefs} from "vue";

export default defineComponent({
  name: 'TenderOrdersCounter',

  props: {
    /**
     * Тендер целиком: позиции заказов, единица измерения и признак
     * предзаказа — всё лежит в нём, раскладывать по отдельным пропам незачем.
     */
    tender: {
      type:     Object as PropType<Tender | UnwrapNestedRefs<Tender>>,
      required: true,
    },
  },

  data() {
    return {
      isPopupVisible: false,
    };
  },

  methods: {
    /** Открытие попапа снаружи — по ссылке из шапки карточки. */
    showPopup(): void {
      setTimeout(() => {
        this.isPopupVisible = true;
      }, 0);
    },

    async openPositionCard(position: OrderPosition): Promise<void> {
      this.isPopupVisible = false;

      await this.$core.dialogs.OrderPositionCard.showAsPromise({
        id:          position.id,
        isPreorder:  position.isPreorder,
        isAdminMode: this.$core.currentUser.isAdmin,
      });
    },
  },
});
</script>
